import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, parsePrinterXML } from '../../helpers';
import URLSearchParams from '@ungap/url-search-params';
import Dymo from '../../lib/labels/dymojs';
import Boca from '../../lib/labels/boca';
import Star from '../../lib/labels/star';
import moment from 'moment';
import { DateUtils } from 'react-day-picker';
import en from './locales/en.json';
import fr from './locales/fr.json';
import SearchForm from './SearchForm/SearchForm';
import SearchResults from './SearchResults/SearchResults';
import Filters from './Filters/Filters';
import Message from '../Common/Message/Message';
import AlertModal from '../Common/AlertModal/AlertModal';
import ReleaseRefundClientModal from './ReleaseRefundClientModal/ReleaseRefundClientModal';
import ReleaseRefundCustomerModal from './ReleaseRefundCustomerModal/ReleaseRefundCustomerModal';
import ReleaseRefundTicketModal from './ReleaseRefundTicketModal/ReleaseRefundTicketModal';
import RefundErrorModal from './RefundErrorModal/RefundErrorModal';
import RefundSuccessModal from './RefundSuccessModal/RefundSuccessModal';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: ''
            },
            query: {
                keyword: '',
                transaction_number: '',
                event: 0,
                flexpass: 0,
                date: 0
            },
            transaction_start: undefined,
            transaction_end: undefined,
            events: [],
            flexpasses: [],
            dates: [],
            coupons: [],
            tags: [],
            filters: {
                checkinStatus: [],
                transactionStatus: [],
                coupons: [],
                tags: []
            },
            user: {},
            customers: [],
            selectedIds: [],
            isModalOpen: false,
            isReleaseRefundClientOpen: false,
            isReleaseRefundCustomerOpen: false,
            isReleaseRefundTicketOpen: false,
            isRefundSuccessOpen: false,
            isRefundErrorOpen: false,
            modalTitle: '',
            modalDescription: '',
            selectedId: 0,
            actionType: '',
            elementType: '',
            isReserved: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            currentPage: 1,
            maxPage: 50,
            isTransactionInfoHidden: false,
            searchType: 'event',
            hasDoneSearch: false,
            printers: [],
            printersBoca: [],
            currentPrinterBoca: '',
            printersStar: [],
            printersStarUSB: [],
            currentPrinterStar: '',
            eventsResults: [],
            refundEventId: undefined,
            refundDetails: undefined,
            refundTransactionId: undefined,
            refundFlexpassId: undefined,
            transaction_refund_id: -1,
        }
    }

    toggleTransactionInfo = () => {
        this.setState({ isTransactionInfoHidden: !this.state.isTransactionInfoHidden });
    }

    setQuery = (name, value) => {
        const query = {...this.state.query};
        if(name === 'event' || name === 'flexpass'){
            query['date'] = 0;
        }
        query[name] = value;
        this.setState({ query });
    }

    handleChange = (e) => {
        this.setQuery(e.target.name, e.target.value);
    }

    handleKeyUp = (e) => {
        if(e.keyCode === 13){
            this.submitSearch();
        }
    }

    handleChangeEvent = (e) => {
        this.setState({ dates: [] });
        const events = [...this.state.events];
        const flexpasses = [...this.state.flexpasses];
        let searchType = this.state.searchType;

        let index = 0;
        events.forEach((event) => {
            if(parseInt(event.id) === parseInt(e.target.value)){
                index = event;
                searchType = 'event';
            }
        });
        flexpasses.forEach((flexpass) => {
            if(parseInt(flexpass.id) === parseInt(e.target.value)){
                index = flexpass;
                searchType = 'flexpass';
            }
        });

        this.setState({searchType});
        this.setQuery(searchType, e.target.value);
        
        if(e.target.value !== 0){
            if(searchType === 'event'){
                setTimeout(() => {
                    const query = {...this.state.query};
                    query['flexpass'] = 0;
                    this.setState({ query });
                }, 500);
                this.getEventDates(parseInt(e.target.value, 0));
            } else {
                setTimeout(() => {
                    const query = {...this.state.query};
                    query['event'] = 0;
                    this.setState({ query });
                }, 500);
            }
        } else {
            const query = {...this.state.query};
            query['event'] = 0;
            query['date'] = 0;
            this.setState({ query });
        }
    }

    setFilters = (name, value, object) => {
        // Set Query 
        const filters = {...this.state.filters};
        if(object !== ''){
            // If value already in array, remove it. If it's not, add it
            //(filters[object].indexOf(value) !== -1) ? filters[object].splice(filters[object].indexOf(value),1) : filters[object].push(value);
            if(object === 'coupons' || object === 'tags'){
                if(filters[object].indexOf(parseInt(value)) !== -1){
                    filters[object].splice(filters[object].indexOf(parseInt(value)),1);
                } else {
                    filters[object].push(parseInt(value));
                }
            } else {
                if(filters[object].indexOf(value) !== -1){
                    filters[object].splice(filters[object].indexOf(value),1);
                } else {
                    filters[object].push(value);
                }
            }
        } else {
            filters[name] = value;
        }
        this.setState({ filters });
    }

    resetFilters = () => {
        const initialFilters = {...this.baseState.filters};
        this.setState({ filters: initialFilters });
    }

    handleChangeFilter = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        let object = '';
        if(e.target.hasAttribute('object')){
            object = e.target.attributes.getNamedItem('object').value;
        } else {
            (e.target.checked) ? value = true : value = false;
        }
        this.setFilters(name, value, object);
    }

    handleSearch = () => {
        this.setState(
            {
                currentPage: 1,
                maxPage: undefined,
            },
            () => {
                this.submitSearch();
            }
        );
    }

    submitSearch = () => {
        const data = {...this.state};
        const currentPage = this.state.currentPage;

        const doPost = async (data) => {
            try {
                const searchResponse = await search(data, currentPage);
                console.log('Search response: ', searchResponse);

                this.setState({ hasDoneSearch:true });
                if(searchResponse.data.customers.length > 0){
                    let eventsResults = [];
                    if(searchResponse.data.events.length > 0) {
                        eventsResults = searchResponse.data.events;
                    }
                    this.setMessage('', '', '');
                    const customers = [];
                    for(let i=0;i<searchResponse.data.customers.length;i++){
                        customers.push(searchResponse.data.customers[i]);
                    }
                    customers.forEach((customer) => {
                        customer.transactions.forEach((transaction) => {
                            transaction.visible = true;
                            transaction.tickets.forEach((ticket) => {
                                ticket.visible = true;
                            });
                        });    
                    });

                    // Then apply filters
                    this.setState({ 
                        customers:customers,
                        eventsResults
                    }, 
                    () => {
                        /* if(this.state.filters.checkinStatus.length > 0 || this.state.filters.coupons.length > 0 || this.state.filters.tags.length > 0 || this.state.filters.transactionStatus.length > 0){
                            this.applyFilters();
                        } */
                    });
                    //this.setState({ transactions:searchResponse.data.transactions });
                } else {
                    if(this.state.currentPage > 1){
                        this.setState({ maxPage:this.state.currentPage });
                        this.getPrevPage();
                    } else {
                        this.setMessage(window.general_strings.msg.oops, strings.msg.noResults, 'error');
                        this.setState({ customers:[] });
                    }
                }
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        }

        async function search(data, currentPage) {
            let query = `?`;
            let search = data.query.keyword;
            if(search !== ''){
                query += `search=${search}&`;     
            }   

            let transaction_id;
            if(data.query.transaction_number !== undefined && data.query.transaction_number !== ''){
                transaction_id = parseInt(data.query.transaction_number, 0);
                query += `transaction_id=${transaction_id}&`;
            }

            const event_id = parseInt(data.query.event, 0);
            if(event_id !== 0){
                query += `event_id=${event_id}&`;
            }

            const flexpass_id = parseInt(data.query.flexpass, 0);
            if(flexpass_id !== 0){
                query += `flexpass_id=${flexpass_id}&`;
            }

            const event_date_id = parseInt(data.query.date, 0);
            if(event_date_id !== 0){
                query += `event_date_id=${event_date_id}&`;
            }

            if(data.filters.checkinStatus.length > 0 && data.filters.checkinStatus.length < 2){
                data.filters.checkinStatus.forEach((checkin) => {
                    if(checkin === "true"){
                        query += `ticket_checked_in=yes&`;
                    } else {
                        query += `ticket_checked_in=no&`;
                    }
                });
            } else {
                //query += `ticket_checked_in=no&`;
            }

            if(data.filters.transactionStatus.length > 0){
                for (var i = 0; i < data.filters.transactionStatus.length; i++) {
                    query += "transaction_status[]=" + data.filters.transactionStatus[i] + "&";
                }
            }

            if(data.filters.coupons.length > 0){
                for (var i = 0; i < data.filters.coupons.length; i++) {
                    query += "coupon_ids[]=" + parseInt(data.filters.coupons[i]) + "&";
                }
            }

            if(data.filters.tags.length > 0){
                for (var i = 0; i < data.filters.tags.length; i++) {
                    query += "tag_ids[]=" + parseInt(data.filters.tags[i]) + "&";
                }
            }

            if(data.transaction_start !== undefined){
                query += `transaction_start=${moment.utc(data.transaction_start.toString().substring(0,15) + " 00:00:00").toISOString()}&`;
            }

            if(data.transaction_end !== undefined){
                query += `transaction_end=${moment.utc(data.transaction_end.toString().substring(0,15) + " 23:59:59").toISOString()}&`;
            }

            query += `page=${currentPage}`;

            return await ApiRequest(`/transactions/search${query}`, {
                method: 'GET'
            });
        }

        this.setMessage('', '', 'loading');
        doPost(data);
    }

    getSum = (total, num) => {
        return total + num;
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    applyFilters = () => {
        this.submitSearch();
    }

    selectAllCheckboxes = (e) => {
        let value = e.target.value;
        (e.target.checked) ? value = true : value = false;
        const table = document.getElementById('searchResultsTbl');
        const inputs = table.querySelectorAll('input');
        inputs.forEach((input) => {
            input.checked = value;
        });

        this.updateSelectedIds();
    }

    updateSelectedIds = () => {
        const table = document.getElementById('searchResultsTbl');
        const inputs = table.querySelectorAll('input');
        let selectedIds = [];
        
        inputs.forEach((input) => {
            if(input.checked) {
                selectedIds.push(parseInt(input.value, 0));
            }
        });

        this.setState({ 
            selectedIds
        });
    }

    printSelected = () => {
        async function doRePrint(transaction_id) {
            try {
                const printResponse = await print(transaction_id);
                console.log('printResponse: ', printResponse);
                if(printResponse.data){
                    const pdfString = printResponse.data;
                    var a = window.document.createElement('a');
                    a.setAttribute('href', 'data:application/pdf; charset=utf-8,' + encodeURIComponent(pdfString));
                    a.setAttribute('download', 'transaction_' + transaction_id + '.pdf');
                    a.click();
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function print(transaction_id) {
            return await ApiRequest(`/transactions/${transaction_id}/print`, {
                method: 'GET'
			});
        }

        if(this.state.selectedIds.length > 0){
            this.state.selectedIds.forEach((id) => {
                doRePrint(id);
            });
        }
    }

    dymoPrintSelected = () => {
        async function doRePrint(transaction_id) {
            try {
                const printResponse = await print(transaction_id);
                console.log('printResponse: ', printResponse);
                
            } catch (error) {
                console.log(error);
            }
        }

        async function print(transaction_id) {
            return await ApiRequest(`/transactions/${transaction_id}/print`, {
                method: 'GET'
			});
        }

        if(this.state.selectedIds.length > 0){
            this.state.selectedIds.forEach((id) => {
                doRePrint(id);
            });
        }
    }

    export = () => {
        const data = {...this.state};
        this.setMessage('', '', 'loading');
        const exportCSV = async (data) => {
            try {
                const response = await getCSV(data);
                console.log('response',response);
                this.setMessage('', '', '');

                const csvString = response.data;
                var a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(csvString));
                a.setAttribute('download', 'search_results.csv');
                a.click();

            } catch (error) {
                console.log(error);
                window.scrollTo(0, 0);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        }

        async function getCSV(data) {
            let query = `?`;
            let search = data.query.keyword;
            if(search !== ''){
                query += `search=${search}&`;     
            }   

            let transaction_id;
            if(data.query.transaction_number !== undefined && data.query.transaction_number !== ''){
                transaction_id = parseInt(data.query.transaction_number, 0);
                query += `transaction_id=${transaction_id}&`;
            }

            const event_id = parseInt(data.query.event, 0);
            if(event_id !== 0){
                query += `event_id=${event_id}&`;
            }

            const flexpass_id = parseInt(data.query.flexpass, 0);
            if(flexpass_id !== 0){
                query += `flexpass_id=${flexpass_id}&`;
            }

            const event_date_id = parseInt(data.query.date, 0);
            if(event_date_id !== 0){
                query += `event_date_id=${event_date_id}&`;
            }

            if(data.filters.checkinStatus.length > 0){
                data.filters.checkinStatus.forEach((checkin) => {
                    if(checkin === "true"){
                        query += `ticket_checked_in=yes&`;
                    } else {
                        query += `ticket_checked_in=no&`;
                    }
                });
            } else {
                //query += `ticket_checked_in=no&`;
            }

            if(data.filters.transactionStatus.length > 0){
                for (var i = 0; i < data.filters.transactionStatus.length; i++) {
                    query += "transaction_status[]=" + data.filters.transactionStatus[i] + "&";
                }
            }

            if(data.filters.coupons.length > 0){
                for (var i = 0; i < data.filters.coupons.length; i++) {
                    query += "coupon_ids[]=" + parseInt(data.filters.coupons[i]) + "&";
                }
            }

            if(data.filters.tags.length > 0){
                for (var i = 0; i < data.filters.tags.length; i++) {
                    query += "tag_ids[]=" + parseInt(data.filters.tags[i]) + "&";
                }
            }

            if(data.transaction_start !== undefined){
                query += `transaction_start=${moment.utc(data.transaction_start.toString().substring(0,15) + " 00:00:00").toISOString()}&`;
            }

            if(data.transaction_end !== undefined){
                query += `transaction_end=${moment.utc(data.transaction_end.toString().substring(0,15) + " 23:59:59").toISOString()}&`;
            }

            return await ApiRequest(`/transactions/search/export${query}`, {
                method: "GET"
            });
            
        }

        exportCSV(data);
    }

    toggleAlertModal = (e) => {
        if(typeof(e) !== "undefined"){
            if(e.target.hasAttribute('id')){
                this.setState({
                    selectedId: e.target.attributes.getNamedItem('id').value
                });
            }
            if(e.target.hasAttribute('action')){
                this.setState({
                    actionType: e.target.attributes.getNamedItem('action').value
                });
            }
            if(e.target.hasAttribute('type')){
                this.setState({
                    elementType: e.target.attributes.getNamedItem('type').value
                });
            }
            if(e.target.hasAttribute('reserved')){
                this.setState({
                    isReserved: e.target.attributes.getNamedItem('reserved').value
                });
            }
            if(e.target.hasAttribute('title')){
                this.setState({
                    modalTitle: e.target.attributes.getNamedItem('title').value
                });
            }
            if(e.target.hasAttribute('description')){
                this.setState({
                    modalDescription: e.target.attributes.getNamedItem('description').value
                });
            }
        }
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    toggleRefundErrorModal = () => {
        this.setState({
            isRefundErrorOpen: !this.state.isRefundErrorOpen
        });
    }

    toggleRefundSuccessModal = () => {
        this.setState({
            isRefundSuccessOpen: !this.state.isRefundSuccessOpen
        });
    }

    toggleReleaseRefundModal = (e) => {
        let transactionId = e.target.hasAttribute('id') ? e.target.attributes.getNamedItem('id').value : undefined;
        const refundType = e.target.hasAttribute('type') ? e.target.attributes.getNamedItem('type').value : undefined;
        let ticketId = null;
        let flexpassId = null;
        
        if (refundType === 'ticket') {
            transactionId = e.target.hasAttribute('transaction_id') ? e.target.attributes.getNamedItem('transaction_id').value : undefined;
            ticketId = e.target.hasAttribute('id') ? parseInt(e.target.attributes.getNamedItem('id').value, 10) : undefined;
        }

        if (refundType === 'flexpass') {
            transactionId = e.target.hasAttribute('transaction_id') ? e.target.attributes.getNamedItem('transaction_id').value : undefined;
            flexpassId = e.target.hasAttribute('id') ? parseInt(e.target.attributes.getNamedItem('id').value, 10) : undefined;
        }

        const doCheckRefundTransactionDetails = async (transactionId, ticketId, flexpassId) => {
            try {
                const checkRefundResponse = await checkRefundTransactionDetails(transactionId, ticketId, flexpassId);
                console.log('checkRefundResponse: ', checkRefundResponse);
                if (checkRefundResponse.data.refundDetails && checkRefundResponse.data.refundDetails.length > 0) {
                    let isClientOnly = false;
                    checkRefundResponse.data.refundDetails.forEach((refundDetail) => {
                        if (refundDetail.type === 'per-ticket' && refundDetail.service_fee === 'client') {
                            isClientOnly = true;
                        }
                    });
                    console.log('isClientOnly', isClientOnly)
                    console.log('ticketId', ticketId)
                    if (!isClientOnly) {
                        if (!ticketId) {
                            if (!flexpassId) {
                                this.setState({
                                    isReleaseRefundCustomerOpen: !this.state.isReleaseRefundCustomerOpen,
                                });
                            } else {
                                this.setState({
                                    isReleaseRefundTicketOpen: !this.state.isReleaseRefundTicketOpen,
                                });
                            }
                        } else {
                            this.setState({
                                isReleaseRefundTicketOpen: !this.state.isReleaseRefundTicketOpen,
                            });
                        }
                    } else {
                        this.setState({
                            isReleaseRefundClientOpen: !this.state.isReleaseRefundClientOpen,
                        });
                    }
                    this.setState({
                        refundTicketId: ticketId,
                        refundFlexpassId: flexpassId,
                        refundTransactionId: transactionId,
                        refundDetails: checkRefundResponse.data.refundDetails,
                    });
                    if (!checkRefundResponse.data.can_refund) {
                        let transaction_refund_id = checkRefundResponse.data.transaction_refund_id || -1;
                        this.setState({
                            isReleaseRefundCustomerOpen: false,
                            isReleaseRefundClientOpen: false,
                            isReleaseRefundTicketOpen: false,
                            isRefundErrorOpen: true,
                            transaction_refund_id,
                        });
                    }
                } else {
                    let transaction_refund_id = checkRefundResponse.data.transaction_refund_id || -1;
                    this.setState({
                        isReleaseRefundCustomerOpen: false,
                        isReleaseRefundClientOpen: false,
                        isRefundErrorOpen: true,
                        transaction_refund_id,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function checkRefundTransactionDetails(transactionId) {
            return await ApiRequest(`/transactions/${transactionId}/refund-detail`, {
                method: 'GET'
			});
        }

        if (transactionId && refundType === 'transaction') {
            doCheckRefundTransactionDetails(transactionId);
        } else if (ticketId && refundType === 'ticket') {
            doCheckRefundTransactionDetails(transactionId, ticketId);
        } else if (flexpassId && refundType === 'flexpass') {
            doCheckRefundTransactionDetails(transactionId, ticketId, flexpassId);
        } else {
            this.setState({
                refundTicketId: undefined,
                refundTransactionId: undefined,
                refundFlexpassId: undefined,
                isReleaseRefundCustomerOpen: false,
                isReleaseRefundClientOpen: false,
                isReleaseRefundTicketOpen: false,
            });
        }
    }

    confirmCustomerRefund = (service_fee) => {
        const refundTransactionId = this.state.refundTransactionId;
        const doRefund = async (refundTransactionId) => {
            try {
                const refundResponse = await refund(refundTransactionId, service_fee);
                console.log('refundResponse: ', refundResponse);
                if (refundResponse.data.transaction_refund_id) {
                    this.setState({
                        isRefundSuccessOpen: true,
                    });
                    this.afterAction(window.general_strings.msg.yay,'','success');
                } else {
                    this.setState({
                        isRefundErrorOpen: true,
                    });
                }
                this.setState({
                    isReleaseRefundTicketOpen: false,
                    isReleaseRefundCustomerOpen: false,
                    isReleaseRefundClientOpen: false,
                });
            } catch (error) {
                console.log(error);
            }
        }

        async function refund(refundTransactionId, service_fee) {
            return await ApiRequest(`/transactions/${refundTransactionId}/refund`, {
                method: 'POST',
                data: {
                    service_fee,
                }
			});
        }

        doRefund(refundTransactionId, service_fee);
    }

    confirmClientRefund = () => {
        const refundTransactionId = this.state.refundTransactionId;
        const doRefund = async (refundTransactionId) => {
            try {
                const refundResponse = await refund(refundTransactionId);
                console.log('refundResponse: ', refundResponse);
                if (refundResponse.data.transaction_refund_id) {
                    this.setState({
                        isRefundSuccessOpen: true,
                    });
                    this.afterAction(window.general_strings.msg.yay,'','success');
                } else {
                    this.setState({
                        isRefundErrorOpen: true,
                    });
                }
                this.setState({
                    isReleaseRefundTicketOpen: false,
                    isReleaseRefundCustomerOpen: false,
                    isReleaseRefundClientOpen: false,
                });
            } catch (error) {
                console.log(error);
            }
        }

        async function refund(refundTransactionId) {
            return await ApiRequest(`/transactions/${refundTransactionId}/refund`, {
                method: 'POST',
                data: {
                    service_fee: 'client',
                }
			});
        }

        doRefund(refundTransactionId);
    }

    confirmTicketRefund = () => {
        const refundTransactionId = this.state.refundTransactionId;
        const refundTicketId = this.state.refundTicketId;
        const refundFlexpassId = this.state.refundFlexpassId;
        const doRefund = async (refundTransactionId) => {
            try {
                const refundResponse = await refund(refundTransactionId, refundTicketId, refundFlexpassId);
                console.log('refundResponse: ', refundResponse);
                if (refundResponse.data.transaction_refund_id) {
                    this.setState({
                        isRefundSuccessOpen: true,
                    });
                    this.afterAction(window.general_strings.msg.yay,'','success');
                } else {
                    this.setState({
                        isRefundErrorOpen: true,
                    });
                }
                this.setState({
                    isReleaseRefundTicketOpen: false,
                    isReleaseRefundCustomerOpen: false,
                    isReleaseRefundClientOpen: false,
                });
            } catch (error) {
                console.log(error);
            }
        }

        async function refund(refundTransactionId, refundTicketId, refundFlexpassId) {
            let data = {};
            data.service_fee = 'client';
            if (refundTicketId) {
                data.ticket_id = refundTicketId;
            }
            if (refundFlexpassId) {
                data.transaction_flexpass_id = refundFlexpassId;
            }
            return await ApiRequest(`/transactions/${refundTransactionId}/refund`, {
                method: 'POST',
                data,
			});
        }

        doRefund(refundTransactionId, refundTicketId);
    }

    confirmAlertModal = () => {
        switch(this.state.actionType){
            case 'release':
            this.release(this.state.selectedId);
            break;

            case 'delete':
            this.delete(this.state.selectedId);
            break;

            default:
            this.release(this.state.selectedId);
            break;
        }

        this.setState({
            isModalOpen: false
        });
    }

    
    release = (id) => {
        this.setMessage('','','loading');
        const doReleaseTransaction = async () => {
            try {
                const releaseTransactionResponse = await releaseTransaction(id);
                console.log('releaseTransactionResponse: ', releaseTransactionResponse);

                if(releaseTransactionResponse.data.success){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.transactionReleased,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,releaseTransactionResponse.data.error.message,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,error);
            }
        }

        async function releaseTransaction(transaction_id) {
            return await ApiRequest(`/transactions/${transaction_id}/release`,
            {
                method: 'POST'
            });
        }

        const doReleaseTicket = async () => {
            try {
                const releaseTicketResponse = await releaseTicket(id);
                console.log('releaseTicketResponse: ', releaseTicketResponse);

                if(!releaseTicketResponse.data.error){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.ticketReleased,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,releaseTicketResponse.data.error.message,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,error);
            }
        }

        async function releaseTicket(ticket_id) {
            return await ApiRequest(`/transactions/tickets/${ticket_id}/release`,
            {
                method: 'POST'
            });
        }

        if(this.state.elementType === 'transaction'){
            doReleaseTransaction();
        } else {
            doReleaseTicket();
        }
        
    }

    delete = (id) => {
        this.setMessage('','','loading');
        const doDeleteTransaction = async () => {
            try {
                const deleteTransactionResponse = await deleteTransaction(id);
                console.log('deleteTransactionResponse: ', deleteTransactionResponse);

                if(deleteTransactionResponse.data.success){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.transactionDeleted,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,deleteTransactionResponse.data.error.message,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,error);
            }
        }

        async function deleteTransaction(transaction_id) {
            return await ApiRequest(`/transactions/${transaction_id}/delete`,
            {
                method: 'POST'
            });
        }

        const doDeleteTicket = async () => {
            try {
                const deleteTicketResponse = await deleteTicket(id);
                console.log('deleteTicketResponse: ', deleteTicketResponse);

                if(deleteTicketResponse.data.success){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.ticketReleased,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,deleteTicketResponse.data.error.message,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,error);
            }
        }

        async function deleteTicket(ticket_id) {
            return await ApiRequest(`/transactions/tickets/${ticket_id}`,
            {
                method: 'DELETE'
            });
        }

        const doDeleteReservedTicket = async () => {
            try {
                const deleteTicketResponse = await deleteReservedTicket(id);
                console.log('deleteTicketResponse: ', deleteTicketResponse);

                if(deleteTicketResponse.data.success){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.ticketReleased,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,deleteTicketResponse.data.error.message,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,error);
            }
        }

        async function deleteReservedTicket(ticket_id) {
            return await ApiRequest(`/transactions/tickets/reservation/${ticket_id}`,
            {
                method: 'DELETE'
            });
        }

        if(this.state.elementType === 'transaction'){
            doDeleteTransaction();
        } else {
            if(this.state.isReserved){
                doDeleteReservedTicket();
            } else {
                doDeleteTicket();
            }
        }
    }

    afterAction = (title, description, type) => {
        this.setMessage(title,description,type);
        setTimeout(() => {
            this.setMessage('', '', '');

            // Reload Transactions
            this.submitSearch();
        }, 1000);
        this.setState({ 
            selectedId:0,
            elementType:'',
            actionType:'',
            modalTitle:'',
            modalDescription:'',
            isReserved:false
        });
    }

    toggleArchived = (e) => {
        const customerId = parseInt(e.target.id, 0);
        const customers = [...this.state.customers];
        const index = customers.findIndex(customer => {
            return customer.id === customerId;
        });
        const doGetArchives = async () => {
            try {
                const archivesResponse = await get_archives(customerId);
                console.log('archivesResponse: ', archivesResponse);

                if(archivesResponse.data.transactions.length > 0){
                    this.setMessage('', '', '');
                    
                    if(index !== -1){
                        let eventsResults = this.state.eventsResults;
                        let archives = [];
                        archivesResponse.data.transactions.forEach((transaction) => {
                            archives.push(transaction);
                        });
                        archives.forEach((archive) => {
                            archive.visible = true;
                            if(!archive.flexpasses) {
                                archive.flexpasses = [];
                            }
                            archive.tickets.forEach((ticket) => {
                                ticket.visible = true;
                            });
                        });
                        customers[index].archives = archives;
                        archivesResponse.data.events.forEach((event) => {
                            eventsResults.push(event);
                        });
                        this.setState({ 
                            customers,
                            eventsResults,
                        });
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, strings.msg.noArchives, 'error');
                }
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        }

        async function get_archives(customer_id) {
            return await ApiRequest(`/transactions/search/archive?customer_id=${customer_id}`, {
                method: 'GET'
            });
        }

        if(index !== -1 && customers[index].archives === undefined){
            this.setMessage('', '', 'loading');
            doGetArchives();
        }
    }

    getEventDates = (event_id) => {
        const events = [...this.state.events];
        const index = events.findIndex(x => {
            return parseInt(x.id, 0) === event_id;
        });
        if(index !== -1){
            if(typeof(events[index].event_dates) !== 'undefined'){
                let dates = events[index].event_dates;
                this.setState({ 
                    dates,
                });
            }
        }
    }

    getEventFromDate = (date_id) => {
        const events = [...this.state.events];
        let index = 0;

        // Find Event Id
        let eventId = 0;
        events.forEach((event) => {
            event.event_dates.forEach((date) => {
                if(parseInt(date.id, 0) === date_id){
                    eventId = event.id;
                }
            });
        });

        if(eventId > 0){
            this.getEventDates(parseInt(eventId, 0));
            this.setQuery('event', parseInt(eventId, 0));
            setTimeout(() => {
                this.setQuery('date', date_id);
            }, 500);
        }
    }

    loadData = (props) => {
        if(typeof props !== 'undefined'){
            this.setState(
                { user:props.user },
                () => {
                    getData();
                }
            );
            this.setMessage('', '', 'loading');
            // Get user first
            const getData = async () => {
                try {
                    if(this.state.user.id){
                        // Get client events
                        const eventsResponse = await getEvents();
                        console.log('eventsResponse response: ', eventsResponse);
                        if(eventsResponse.data.events){
                            this.setState(
                                { events: eventsResponse.data.events },
                                () => {
                                    if(this.props.routeProps.match.params.query !== undefined || this.props.routeProps.match.params.filter !== undefined){
                                        // If there are url parameters
                                        const params = this.props.routeProps.match.params;
                                        switch (params.query) {
                                            case 'event':
                                                this.setQuery('event', parseInt(params.id, 0));
                                                this.getEventDates(parseInt(params.id, 0));
                                                break;

                                            case 'flexpass':
                                                this.setQuery('flexpass', parseInt(params.id, 0));
                                                break;
        
                                            case 'date':
                                                this.getEventFromDate(parseInt(params.id, 0));
                                                break;

                                            case 'transaction':
                                                this.setQuery('transaction_number', params.id);
                                                break;
        
                                            default:
                                                this.setQuery('keyword', params.query);
                                                break;
                                        }

                                        if(params.filter !== undefined){
                                            this.setFilters(params.filter, params.filter, 'transactionStatus');
                                        }

                                        setTimeout(() => {
                                            this.submitSearch();
                                        }, 750);
                                    }    

                                    // From - To Search
                                    if (this.props.routeProps.location.search !== '') {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const paramFrom = urlParams.get('transaction_start');
                                        const paramTo = urlParams.get('transaction_end');

                                        this.setState(
                                            {
                                                transaction_start: moment(`${paramFrom} 00:00:00`).toDate(),
                                                transaction_end: moment(`${paramTo} 23:59:59`).toDate(),
                                            }, () => {
                                                this.submitSearch();
                                            }
                                        )
                                    }
                                }
                            );
                            this.setMessage('', '', '');
                        } else {
                            this.setMessage(window.general_strings.msg.oops, eventsResponse.data.error, 'error');
                        }

                        // Get client flexpasses
                        const flexpassResponse = await getFlexpasses();
                        console.log('flexpassResponse response: ', flexpassResponse);
                        if(flexpassResponse.data.flexpasses){
                            this.setState({ flexpasses: flexpassResponse.data.flexpasses });
                            this.setMessage('', '', '');
                        } else {
                            this.setMessage(window.general_strings.msg.oops, flexpassResponse.data.error, 'error');
                        }
    
                        // Get client coupons
                        const couponsResponse = await getCoupons();
                        //console.log('couponsResponse response: ', couponsResponse);
                        if(couponsResponse.data.coupons){
                            this.setState({ coupons: couponsResponse.data.coupons });
                        }
    
                        // Get client tags
                        const tagsResponse = await getTags();
                        //console.log('tagsResponse response: ', tagsResponse);
                        if(tagsResponse.data.tags){
                            this.setState({ tags: tagsResponse.data.tags });
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            };
    
            async function getEvents() {
                return await ApiRequest(`/events/`);
            }

            async function getFlexpasses() {
                return await ApiRequest(`/flexpass/`);
            }
    
            async function getCoupons() {
                return await ApiRequest(`/coupons`);
            }
    
            async function getTags() {
                return await ApiRequest(`/tags`);
            }
        }
    }

    getNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage++;
        const top = document.getElementById('searchResultsTbl').getBoundingClientRect().top;
        window.scrollTo(0, top);
        this.setState({ currentPage },
        () => {
            this.submitSearch();
        });
    }

    getPrevPage = () => {
        let currentPage = this.state.currentPage;
        currentPage--;
        const top = document.getElementById('searchResultsTbl').getBoundingClientRect().top;
        window.scrollTo(0, top);
        if(currentPage < 1){
            currentPage = 1;
        }
        this.setState({ currentPage },
        () => {
            this.submitSearch();
        });
    }

    handlePrinterChange = (e) => {
        let value = e.target.value;
        let currentPrinter = { ...this.state.currentPrinter };
        currentPrinter = value;
        this.setState({ currentPrinter });
    }

    detectDymoPrinter = async () => {
        try {
            let dymo = new Dymo();
            const responsePrinters = await dymo.getPrinters();
            console.log('Get Dymo Printers: ', responsePrinters);
            if (responsePrinters) {
                let printers = responsePrinters || [];
                console.log(printers);
                this.setState({
                    printers,
                    currentPrinter: printers[0]
                })
            }
        } catch (error) {
            console.log(error, 'Dymo Printer', 'Trying alternative method...');
            try {
                let dymo = new Dymo({ hostname: '127.0.0.1' });
                const responsePrinters = await dymo.getPrinters();
                console.log('Get Dymo Printers: ', responsePrinters);
                if (responsePrinters) {
                    let printers = responsePrinters || [];
                    console.log(printers);
                    this.setState({
                        printers,
                        currentPrinter: printers[0]
                    })
                }
            } catch (error) {
                console.log(error, 'Dymo Printer', 'Failure.');
            }
        }
    }

    handlePrinterChangeBoca = (e) => {
        let value = e.target.value;
        let currentPrinterBoca = { ...this.state.currentPrinterBoca };
        currentPrinterBoca = value;
        this.setState({ currentPrinterBoca });
        localStorage.setItem('defaultBocaPrinter', currentPrinterBoca);
    };

    detectBocaPrinter = () => {
        let currentPrinterBoca = localStorage.getItem('defaultBocaPrinter') ? localStorage.getItem('defaultBocaPrinter') : '';
        this.setState({
            currentPrinterBoca,
        });
        try {
            let boca = new Boca();
            boca.getJSPrintManager();
            boca.getBocaPrinters().then((responsePrinters) => {
                console.log("responsePrinters", responsePrinters);
                if (responsePrinters) {
                    console.log("has boca printer");
                    let bocaPrinters = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('boca'));
                    let starPrintersUSB = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('star'));
                    this.setState({
                        printersBoca: bocaPrinters,
                        printersStarUSB: starPrintersUSB,
                    });
                }
            },(error) => {
                console.log("no boca printer");
            });
        } catch (error) {
            console.log(error, 'Boca Printer', 'Failure.');
        }
    };

    handlePrinterChangeStar = (e) => {
        let value = e.target.value;
        let currentPrinterStar = { ...this.state.currentPrinterStar };
        currentPrinterStar = value;
        this.setState({ currentPrinterStar });
        localStorage.setItem('defaultStarPrinter', currentPrinterStar);
    };

    detectStarPrinter = async () => {
        let currentPrinterStar = localStorage.getItem('defaultStarPrinter') ? localStorage.getItem('defaultStarPrinter') : '';
        this.setState({
            currentPrinterStar,
        });
        let printersStar = this.state.printersStar;
        //let printersStarUSB = this.state.printersStarUSB;
        try {
            /* let star = new Star();
            star.getStarPrinters2().then((responsePrinters) => {
                console.log('responsePrinters USB', responsePrinters)
                if (responsePrinters) {
                    printersStarUSB = responsePrinters;
                    this.setState({
                        printersStarUSB,
                    });
                }
            },(error) => {
                console.log("no boca printer");
            }); */

            const getPrintersResponse = await getStarPrinters();
            console.log('getPrintersResponse', getPrintersResponse);
            if (getPrintersResponse.data.printers) {
                printersStar = getPrintersResponse.data.printers;
                this.setState({
                    printersStar,
                });
            }
        } catch (error) {
            console.log(error);
        }

        async function getStarPrinters() {
            return await ApiRequest(`/printers`, {
                method: 'GET',
            });
        }
    };

    handleChangeDateEvent = (value, id) => {
        const dates = [...this.state.dates];
        this.setState({ 
            [id]: value !== undefined ? moment(value.toString().substring(0,15) + " 00:00:00").toDate() : undefined,
        });
    }

    componentDidMount() {
        this.baseState = JSON.parse(JSON.stringify(this.state));
        this.loadData(this.props);
        
        setTimeout(() => {
            this.detectStarPrinter();
            this.detectBocaPrinter();
            this.detectDymoPrinter();
        }, 2000);

        (async () => {
            try {
                const response = await getCurrentClient();
                console.log('Current Client Response: ', response);
                this.setState({ client: response.data.client || {} });
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCurrentClient() {
            return await ApiRequest('/clients/current');
        }
    }

    render() {
        return (
            <div>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={this.state.modalTitle}
                    modalDescription={this.state.modalDescription}
                />
                <ReleaseRefundCustomerModal
                    isReleaseRefundCustomerOpen={this.state.isReleaseRefundCustomerOpen}
                    toggleReleaseRefundModal={this.toggleReleaseRefundModal}
                    confirmAlertModal={this.confirmAlertModal}
                    refundDetails={this.state.refundDetails}
                    confirmCustomerRefund={this.confirmCustomerRefund}
                />
                <ReleaseRefundClientModal
                    isReleaseRefundClientOpen={this.state.isReleaseRefundClientOpen}
                    toggleReleaseRefundModal={this.toggleReleaseRefundModal}
                    confirmAlertModal={this.confirmAlertModal}
                    refundDetails={this.state.refundDetails}
                    confirmClientRefund={this.confirmClientRefund}
                />
                <ReleaseRefundTicketModal
                    isReleaseRefundTicketOpen={this.state.isReleaseRefundTicketOpen}
                    toggleReleaseRefundModal={this.toggleReleaseRefundModal}
                    confirmAlertModal={this.confirmAlertModal}
                    refundDetails={this.state.refundDetails}
                    refundTicketId={this.state.refundTicketId}
                    refundFlexpassId={this.state.refundFlexpassId}
                    confirmTicketRefund={this.confirmTicketRefund}
                />
                <RefundErrorModal
                    isRefundErrorOpen={this.state.isRefundErrorOpen}
                    toggleRefundErrorModal={this.toggleRefundErrorModal}
                    transaction_refund_id={this.state.transaction_refund_id}
                />
                <RefundSuccessModal
                    isRefundSuccessOpen={this.state.isRefundSuccessOpen}
                    toggleRefundSuccessModal={this.toggleRefundSuccessModal}
                />
                <SearchForm
                    items={this.state}
                    handleChange={this.handleChange}
                    handleChangeEvent={this.handleChangeEvent}
                    handleKeyUp={this.handleKeyUp}
                    handleSearch={this.handleSearch}
                    handleChangeDateEvent={this.handleChangeDateEvent}
                />
                {this.state.hasDoneSearch &&
                    <Filters
                        items={this.state}
                        handleChangeFilter={this.handleChangeFilter}
                        applyFilters={this.applyFilters}
                        resetFilters={this.resetFilters}
                    />
                }
                <div className="container">
                    <Message 
                        message={this.state.message}
                    />
                </div>
                {this.state.customers.length > 0 &&
                    <div>
                        <div className="container d-flex align-items-center justify-content-between">
                            <button 
                                className={this.state.currentPage === 1 ? "showtix-button showtix-background__primary-1 is-disabled":"showtix-button showtix-background__primary-1"}
                                onClick={this.getPrevPage}
                                disabled={this.state.currentPage === 1}
                            >
                                {strings.previous}
                            </button>
                            <span>
                                Page {this.state.currentPage}
                            </span>
                            <button 
                                className={this.state.currentPage === (this.state.maxPage-1) ? "showtix-button showtix-background__primary-1 is-disabled":"showtix-button showtix-background__primary-1"}
                                onClick={this.getNextPage}
                                disabled={this.state.currentPage === (this.state.maxPage-1)}
                            >
                                {strings.next}
                            </button>
                        </div> 
                        <SearchResults
                            items={this.state}
                            selectAllCheckboxes={this.selectAllCheckboxes}
                            updateSelectedIds={this.updateSelectedIds}
                            toggleAlertModal={this.toggleAlertModal}
                            toggleArchived={this.toggleArchived}
                            toggleTransactionInfo={this.toggleTransactionInfo}
                            toggleReleaseRefundModal={this.toggleReleaseRefundModal}
                            setMessage={this.setMessage}
                            printers={this.state.printers}
                            currentPrinter={this.state.currentPrinter}
                            handlePrinterChange={this.handlePrinterChange}
                            printersBoca={this.state.printersBoca}
                            currentPrinterBoca={this.state.currentPrinterBoca}
                            handlePrinterChangeBoca={this.handlePrinterChangeBoca}
                            printersStar={this.state.printersStar}
                            printersStarUSB={this.state.printersStarUSB}
                            currentPrinterStar={this.state.currentPrinterStar}
                            handlePrinterChangeStar={this.handlePrinterChangeStar}
                            eventsResults={this.state.eventsResults}
                            isGodMode={this.props.isGodMode}
                        />

                        <div className="container pb-2 d-flex align-items-center justify-content-between">
                            <button 
                                className={this.state.currentPage === 1 ? "showtix-button showtix-background__primary-1 is-disabled":"showtix-button showtix-background__primary-1"}
                                onClick={this.getPrevPage}
                                disabled={this.state.currentPage === 1}
                            >
                                {strings.previous}
                            </button>
                            <span>
                                Page {this.state.currentPage}
                            </span>
                            <button 
                                className={this.state.currentPage === (this.state.maxPage-1) ? "showtix-button showtix-background__primary-1 is-disabled":"showtix-button showtix-background__primary-1"}
                                onClick={this.getNextPage}
                                disabled={this.state.currentPage === (this.state.maxPage-1)}
                            >
                                {strings.next}
                            </button>
                        </div>   
                
                        <div className="container pb-2">
                            {/*  (!this.state.isTransactionInfoHidden && this.state.selectedIds.length > 0) &&
                                <React.Fragment>
                                    <button 
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.printSelected}
                                    >
                                        {strings.printSelected}
                                    </button>
                                    <button 
                                        className="showtix-button showtix-background__primary-2"
                                        onClick={this.dymoPrintSelected}
                                    >
                                        {strings.dymoPrintSelected}
                                    </button>
                                </React.Fragment>
                            */}
                            <button 
                                className="showtix-button showtix-background__primary-3"
                                onClick={this.export}
                            >
                                {strings.exportCSV}
                            </button>
                        </div>   
                    </div>
                }          
            </div>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search/Search.js